import { render, staticRenderFns } from "./UploadBackground.vue?vue&type=template&id=5cc00e20"
import script from "./UploadBackground.vue?vue&type=script&lang=js"
export * from "./UploadBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports